import { fork, all } from 'redux-saga/effects'
import authRoot from './auth'
import buyRoot from './buy'
import commentsRoot from './comments'
import feedRoot from './feed'
import itemsRoot from './items'
import kitsRoot from './kits'
import notificationsRoot from './notifications'
import postsRoot from './posts'
import searchRoot from './search'
import userProfileRoot from './userProfile'

// TODO: could change to spawn (or fork and catch task.done) for the watchers (here or in the others, or both?), make them auto-restarting (check throwing unhandled exceptions in them)
// this is interesting: https://github.com/redux-saga/redux-saga/pull/644, as is https://github.com/redux-saga/redux-saga/issues/760 (and 570)

export default function* root() {
	yield all([
		fork(authRoot),
		fork(buyRoot),
		fork(commentsRoot),
		fork(feedRoot),
		fork(itemsRoot),
		fork(kitsRoot),
		fork(notificationsRoot),
		fork(postsRoot),
		fork(searchRoot),
		fork(userProfileRoot)
	])
}



// WEBPACK FOOTER //
// ./src/redux/saga/index.js